(function () {
  var auctionHandles = ['maglia-originale-e-autografata-campionato-arancione-de-gennaro-copia', 'maglia-indossata-e-autografata-adigwe'];
  function fixCards() {
    document.querySelectorAll('[data-essential-upsell-element="product"]').forEach(function(card) {
      var title = card.querySelector('a[data-essential-upsell-element="title"]');
      if (!title || !auctionHandles.some(function(handle) { return new URL(title.href).pathname === '/products/' + handle; })) return;
      card.classList.add('imoco-app-auction');
      if (!card.querySelector('.imoco-auction-link')) {
        var link = document.createElement('a');
        link.className = 'button imoco-auction-link'; link.href = title.href; link.textContent = 'Vai all’asta';
        card.appendChild(link);
      }
    });
  }
  var scheduled = false;
  new MutationObserver(function() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function() { scheduled = false; fixCards(); });
  }).observe(document.body, {childList:true, subtree:true});
  fixCards();
}());
